import { onMount } from "svelte";

const art = `
%c            #############        #############
%c           ####         ##      ####         ##
%c          ##  ##         ##    ##  ##         ##
%c         ##    ##         ##  ##    ##         ##
%c        ##      ##         ####      ##         ##
%c       ##        #############        ##         ##
%c      ##        ##         ####        ##         ##
%c     ##        ##         ##  ##        ##         ##
%c    ##        ##         ##    ##        ##         ##
%c   ##        ##         ##      ##        ##         ##
%c  ##        ##         ##        ##        ##         ##
%c ##        ##         ##          ##        #############
%c  ##      ##         ##            ##      ##         ##
%c   ##    ##         ##              ##    ##         ##
%c    ##  ##         ##                ##  ##         ##
%c     ####         ##                  ####         ##
%c      #############                    #############
%c
%c                         modal.com
`;

const darkColors = [
  "#004d00",
  "#0a5a00",
  "#136600",
  "#1c7300",
  "#268000",
  "#2f8c00",
  "#399900",
  "#42a600",
  "#4cb200",
  "#55bf00",
  "#5fcb00",
  "#68d800",
  "#7FEE64",
  "#7FEE64",
  "#7FEE64",
  "#7FEE64",
  "#7FEE64",
  "#7FEE64",
  "#7FEE64",
];

const lightColors = Array(19).fill("#000000");

export function useConsoleArt(): void {
  onMount(() => {
    const lineCount = (art.match(/%c/g) || []).length;
    if (lineCount !== darkColors.length || lineCount !== lightColors.length) {
      return;
    }

    const isDarkMode = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;
    const colors = isDarkMode ? darkColors : lightColors;
    const cssColors = colors.map(
      (color) => `color:${color}; font-family: monospace;`,
    );
    console.log(art, ...cssColors);
  });
}
